// extracted by mini-css-extract-plugin
var _1 = "NewFeedStyles-module__feed-top___rF9WL";
var _2 = "NewFeedStyles-module__feed-top___rF9WL";
var _3 = "NewFeedStyles-module__new-feed___d6v2v";
var _4 = "NewFeedStyles-module__new-feed___d6v2v";
var _5 = "NewFeedStyles-module__publish-btn___j8bJg";
var _6 = "NewFeedStyles-module__publish-btn___j8bJg";
export { _1 as "feed-top", _2 as "feedTop", _3 as "new-feed", _4 as "newFeed", _5 as "publish-btn", _6 as "publishBtn" }
